var _path, _path2, _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIconActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.543 56.292a.158.158 0 01-.003-.002.029.029 0 010-.007l.002-.001 17.068-9.854.003-.002.003.002.002.002v19.714l-.002.002-.003.001-.003-.001-17.067-9.854z",
    fill: "#D8E0FF",
    stroke: "#1B264F",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.756 42.886c0-.966.784-1.75 1.75-1.75h30.789c6.219 0 11.26 5.041 11.26 11.26v17.292a1.75 1.75 0 01-1.75 1.75H31.506a1.75 1.75 0 01-1.75-1.75V42.886z",
    fill: "#D8E0FF",
    stroke: "#1B264F",
    strokeWidth: 2.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.905,
    y: 28.563,
    width: 43.799,
    height: 30.301,
    rx: 4.75,
    fill: "#fff",
    stroke: "#1B264F",
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#VideoIconActive_svg__clip0_931_11976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "VideoIconActive_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.053 34.051a2 2 0 00-3.157 0l-13.028 16.75-7.199-8.547a2 2 0 00-3.059 0l-13.247 15.73c-1.096 1.3-.171 3.288 1.53 3.288h55.243c1.664 0 2.6-1.914 1.579-3.228L51.053 34.051z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.053 34.051a2 2 0 00-3.157 0l-13.028 16.75-7.199-8.547a2 2 0 00-3.059 0l-13.247 15.73c-1.096 1.3-.171 3.288 1.53 3.288h55.243c1.664 0 2.6-1.914 1.579-3.228L51.053 34.051z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.895 34.051L46.08 32.64l1.816 1.412zm3.158 0l1.815-1.412-1.815 1.412zm-16.185 16.75l-1.76 1.481 1.83 2.174 1.745-2.243-1.815-1.412zm-7.199-8.547l1.76-1.482-1.76 1.482zm-3.059 0l1.76 1.482-1.76-1.482zm-13.247 15.73l1.759 1.481-1.76-1.481zm19.444 3.288l.007-2.3h-.007v2.3zm38.907-3.228l1.816-1.412-1.816 1.412zm-20.003-22.58a.3.3 0 01-.474 0l3.631-2.825c-1.721-2.213-5.066-2.213-6.788 0l3.631 2.824zM36.683 52.212l13.028-16.75-3.63-2.824-13.029 16.75 3.631 2.824zM25.91 43.736l7.198 8.547 3.519-2.964-7.198-8.547-3.519 2.964zm.46 0a.3.3 0 01-.46 0l3.519-2.964a4.3 4.3 0 00-6.578 0l3.518 2.964zm-13.248 15.73l13.247-15.73-3.518-2.964-13.248 15.73 3.519 2.963zm-.23-.494a.33.33 0 01.272.173c.017.036.03.087.022.154a.33.33 0 01-.064.166l-3.519-2.963c-2.355 2.796-.367 7.07 3.29 7.07v-4.6zm17.915 0H12.892v4.6h17.915v-4.6zm.006 0l-.013 4.6h.013v-4.6zm37.323 0H30.813v4.6h37.323v-4.6zm-.237.484a.328.328 0 01-.033-.316.328.328 0 01.27-.168v4.6c3.578 0 5.59-4.116 3.394-6.94l-3.631 2.824zM49.237 35.463L67.9 59.456l3.631-2.824-18.662-23.993-3.63 2.824z",
    fill: "#1B264F",
    mask: "url(#VideoIconActive_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.35 51.477a4.125 4.125 0 118.25 0v14.562h-8.25V51.477z",
    stroke: "#1B264F",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.617,
    cy: 37.02,
    r: 3.105,
    stroke: "#1B264F",
    strokeWidth: 2.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.905,
    y: 28.563,
    width: 43.799,
    height: 30.301,
    rx: 4.75,
    stroke: "#1B264F",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "VideoIconActive_svg__clip0_931_11976"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17.262 28.5)",
    d: "M0 0h43v30H0z"
  })))));
}
export default __webpack_public_path__ + "media/service/VideoIconActive-e126b2a7.svg";
export { SvgVideoIconActive as ReactComponent };